import { IItem } from '@/types/receipt'

export const generateItem = (): IItem => {
  return {
    id: -1,
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
    ocr: '',
    name: '',
    category: null,
    matchedName: null,
    matchedCode: null,
    price: null,
    quantity: 1,
    autoMatchedAt: null,
    isFinallyAutoMatched: false,
    isMatched: false,
    newMatchOkedAt: null,
    reMatchedAt: null,
    reMatchOkedAt: null,
    receiptId: -1,
    receipt: null,
    createdByUserId: null,
    // createdByUser: null,
    updatedByUserId: null,
    // updatedByUser: null,

    originalMatchedCode: null,
    isChanged: false,
  }
}
